<section class="page">
  <header class="page__header">
    <div>
      <h1>Auswertung &amp; Statistik</h1>
      <p>Übersicht aus Beobachtungsliste und Positionen.</p>
    </div>
    <button type="button" class="secondary" (click)="refresh()">Aktualisieren</button>
  </header>

  <div class="stats-grid">
    <div class="stat-card">
      <div class="stat-card__label">Beobachtungen</div>
      <div class="stat-card__value">{{ observationCount() }}</div>
    </div>
    <div class="stat-card">
      <div class="stat-card__label">Offene Positionen</div>
      <div class="stat-card__value">{{ openPositionCount() }}</div>
    </div>
    <div class="stat-card">
      <div class="stat-card__label">Glatt</div>
      <div class="stat-card__value">{{ closedPositionCount() }}</div>
    </div>
    <div class="stat-card">
      <div class="stat-card__label">Gesamt Trades</div>
      <div class="stat-card__value">{{ totalTradesCount() }}</div>
    </div>
  </div>

  <div class="stats-grid stats-grid--secondary">
    <div class="stat-card">
      <div class="stat-card__label">Volumen Beobachtung</div>
      <div class="stat-card__value">{{ observationVolume() | number:'1.2-2' }} €</div>
    </div>
    <div class="stat-card">
      <div class="stat-card__label">Volumen offen</div>
      <div class="stat-card__value">{{ openPositionVolume() | number:'1.2-2' }} €</div>
    </div>
    <div class="stat-card">
      <div class="stat-card__label">Ø Haltedauer (Tage)</div>
      <div class="stat-card__value">{{ averageHoldingDays() | number:'1.0-1' }}</div>
    </div>
    <div class="stat-card">
      <div class="stat-card__label">Ø CRV</div>
      <div class="stat-card__value" [ngClass]="{ 'stat-card__value--warn': averageCrv() > 0 && averageCrv() < 2 }">{{ averageCrv() | number:'1.2-2' }}</div>
    </div>
    <div class="stat-card">
      <div class="stat-card__label">Gewinn/Verlust Verhältnis</div>
      <div class="stat-card__value">
        {{ winningTradesCount() }} / {{ losingTradesCount() }}
        <span class="stat-card__value-sub">({{ lossWinRatioPct() | number:'1.0-1' }}%)</span>
      </div>
    </div>
    <div class="stat-card stat-card--span">
      <div class="stat-card__label">Summe G&amp;V</div>
      <div class="stat-card__value" [ngClass]="{ 'stat-card__value--pos': totalPnl() > 0, 'stat-card__value--neg': totalPnl() < 0 }">{{ totalPnl() | number:'1.2-2' }} €</div>
    </div>
  </div>

  <div class="stats-grid stats-grid--secondary">
    <div class="stat-card">
      <div class="stat-card__label">Summe R</div>
      <div class="stat-card__value" [ngClass]="{ 'stat-card__value--pos': totalR() > 0, 'stat-card__value--neg': totalR() < 0 }">{{ totalR() | number:'1.2-2' }}R</div>
    </div>
    <div class="stat-card">
      <div class="stat-card__label">Durchschnitt R</div>
      <div class="stat-card__value" [ngClass]="{ 'stat-card__value--pos': averageR() > 0, 'stat-card__value--neg': averageR() < 0 }">{{ averageR() | number:'1.2-2' }}R</div>
    </div>
    <div class="stat-card">
      <div class="stat-card__label">Max Drawdown</div>
      <div class="stat-card__value stat-card__value--neg">{{ maxDrawdown() | number:'1.2-2' }} EUR</div>
    </div>
    <div class="stat-card">
      <div class="stat-card__label">Aktueller Drawdown</div>
      <div class="stat-card__value">{{ currentDrawdown() | number:'1.2-2' }} EUR</div>
    </div>
    <div class="stat-card">
      <div class="stat-card__label">Profit Factor</div>
      <div class="stat-card__value">{{ profitFactor() | number:'1.2-2' }}</div>
    </div>
    <div class="stat-card">
      <div class="stat-card__label">Review offen</div>
      <div class="stat-card__value" [ngClass]="{ 'stat-card__value--warn': openReviewCount() > 0 }">{{ openReviewCount() }}</div>
    </div>
    <div class="stat-card">
      <div class="stat-card__label">Regelbrueche/Fehler</div>
      <div class="stat-card__value" [ngClass]="{ 'stat-card__value--warn': ruleBreakCount() > 0 }">{{ ruleBreakCount() }}</div>
    </div>
    <div class="stat-card">
      <div class="stat-card__label">Agent-Trades Trefferquote</div>
      <div class="stat-card__value">{{ agentPositiveRate() | number:'1.0-1' }}%</div>
      <span class="stat-card__value-sub">{{ agentTradeCount() }} Trades</span>
    </div>
  </div>

  <section class="setup-performance" *ngIf="improvementHints().length">
    <header class="section-header">
      <div>
        <h2>Was soll ich verbessern?</h2>
        <p>Erste Hinweise aus R, Review, Fehlern, Screenshots und Agent-Verknuepfungen.</p>
      </div>
    </header>
    <div class="setup-grid">
      <article class="setup-card" *ngFor="let hint of improvementHints()">
        <div class="setup-card__header">
          <div class="setup-card__name">{{ hint }}</div>
        </div>
      </article>
    </div>
  </section>

  <section class="setup-performance">
    <header class="section-header">
      <div>
        <h2>Setup-Erfolg</h2>
        <p>Positive realisierte Ergebnisse je Setup im Verhaeltnis zu allen Ergebnissen.</p>
      </div>
    </header>
    <p class="setup-performance__message" *ngIf="setupPerformanceMessage">{{ setupPerformanceMessage }}</p>

    <div class="setup-grid">
      <article class="setup-card" *ngFor="let setup of setupPerformance; trackBy: setupPerformanceTrack">
        <div class="setup-card__header">
          <div class="setup-card__name">{{ setup.setup }}</div>
          <div
            class="setup-card__rate"
            [ngClass]="{
              'setup-card__rate--good': setup.successRatePct >= 50,
              'setup-card__rate--weak': setup.successRatePct > 0 && setup.successRatePct < 50
            }"
          >
            {{ setup.successRatePct | number:'1.0-1' }}%
          </div>
        </div>
        <div class="setup-card__meter" aria-hidden="true">
          <span [style.width.%]="setup.successRatePct"></span>
        </div>
        <div class="setup-card__stats">
          <div>
            <span>Positiv</span>
            <strong>{{ setup.positiveResults }} / {{ setup.totalResults }}</strong>
          </div>
          <div>
            <span>Negativ</span>
            <strong>{{ setup.negativeResults }}</strong>
          </div>
          <div>
            <span>Neutral</span>
            <strong>{{ setup.neutralResults }}</strong>
          </div>
          <div>
            <span>G&amp;V</span>
            <strong [ngClass]="{ 'stat-card__value--pos': setup.totalPnl > 0, 'stat-card__value--neg': setup.totalPnl < 0 }">
              {{ setup.totalPnl | number:'1.2-2' }} €
            </strong>
          </div>
        </div>
      </article>
    </div>
  </section>

  <section class="chart-card" *ngIf="profitSeries().length; else noData">
    <header class="chart-card__header">
      <div>
        <h2>Gewinnentwicklung</h2>
        <p>Kumuliertes realisiertes Ergebnis in Euro, chronologisch nach Trade-Abschluss.</p>
      </div>
    </header>
    <svg [attr.viewBox]="chartViewBox()" class="profit-chart" role="img" aria-label="Gewinnentwicklung">
      <defs>
        <linearGradient id="profitFill" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stop-color="#58d68d" stop-opacity="0.3" />
          <stop offset="100%" stop-color="#58d68d" stop-opacity="0" />
        </linearGradient>
      </defs>
      <g class="y-grid">
        <ng-container *ngFor="let tick of yAxisTicks()">
          <line [attr.y1]="chartY(tick)" x1="72" x2="960" [attr.y2]="chartY(tick)" />
          <text x="58" [attr.y]="chartY(tick) + 4" class="y-label">{{ formatEuroTick(tick) }}</text>
        </ng-container>
      </g>
      <line class="zero-line" x1="72" x2="960" [attr.y1]="chartZeroY()" [attr.y2]="chartZeroY()" />
      <path class="area" [attr.d]="chartAreaPath()" />
      <path class="line" [attr.d]="chartPath()" />
      <g class="points">
        <circle *ngFor="let point of profitSeries()" [attr.cx]="chartX(point.x)" [attr.cy]="chartY(point.y)" r="4" />
      </g>
      <g class="x-labels">
        <ng-container *ngFor="let label of xAxisLabels()">
          <text [attr.x]="label.x" y="330" class="x-label">{{ label.label }}</text>
        </ng-container>
      </g>
    </svg>
  </section>
  <ng-template #noData>
    <div class="empty-chart">Noch keine Daten für die Gewinnentwicklung.</div>
  </ng-template>
</section>
